type SchedulePeopleViewType = "PeopleView";
type ScheduleShiftViewType = "ShiftView";
export type ScheduleOverViewType = SchedulePeopleViewType | ScheduleShiftViewType ;
export const ScheduleOverViewTypes = {
    PeopleView: "PeopleView" as ScheduleOverViewType,
    ShiftView: "ShiftView" as ScheduleOverViewType
};